<template>
	<c-dialog ref="dialog" title="协同任务详情" mode="slide" width="1200" mask-close :button="false">
		<template #head>
			<div v-if="detailData.task_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.task_code}}</label>
				<c-state :color="detailData.color" tag>{{detailData.type_name}}</c-state>
			</div>
		</template>

		<div class="flex" style="height: 100%;">
			<div class="detail flex-column">
				<div class="detail-scroll flex-grow">
					<!--状态进度条（待响应 → 执行中 → 已完成）-->
					<div class="head flex-between-center">
						<div class="state-steps flex">
							<div v-for="(step, i) in stateSteps" :key="i" class="step-cell flex-center-cross">
								<div class="step-item flex-column flex-center" :class="{'is-active': detailData.task_state == step.state, 'is-wait': detailData.task_state < step.state}">{{step.name}}</div>
								<span v-if="i < stateSteps.length - 1" class="arrow-duration">{{stepDurations[i]}}</span>
							</div>
						</div>
						<div class="total flex-column flex-center">
							<div>{{durationText(totalSeconds)}}</div>
							<p>累计时长</p>
						</div>
					</div>

					<!--基本信息卡-->
					<div class="task">
						<div class="task-title">{{detailData.task_title}}</div>

						<div class="flex-center-cross">
							<div class="task-info flex-center">
								<i class="tf">&#xe61a;</i>
								<span>{{detailData.user_realname}}</span>
								<c-link v-if="auth('b_collabtask_transfer') && detailData.task_state != 3" style="margin-left: 8px;" @click="transferTask">转移</c-link>
							</div>
							<div v-if="detailData.ref_type" class="task-info flex-center">
								<i class="tf">&#xe702;</i>
								<span>关联{{refTypeData.name}}：</span>
								<c-link v-if="refClickable" @click="openRefDetail">{{detailData.ref_code || '-'}}</c-link>
								<span v-else>{{detailData.ref_code || '-'}}</span>
							</div>
						</div>

						<div v-if="detailData.task_desc" class="task-desc">{{detailData.task_desc}}</div>

						<custom-field work-type="51" :data="detailData.customFieldValues" style="margin-top: 10px;"></custom-field>
						
						<div v-if="attachmentList.length" class="task-file">
							<c-file v-for="(file, i) in attachmentList" :key="i" :src="file"></c-file>
						</div>

						<div class="task-date flex-wrap">
							<p>创建时间：{{detailData.create_date || '-'}} ({{detailData.create_user_realname || '-'}})</p>
							<p v-if="detailData.accept_date">响应时间：{{detailData.accept_date}}</p>
							<p v-if="detailData.finish_date">完成时间：{{detailData.finish_date}} ({{detailData.finish_user_realname}})</p>
						</div>
					</div>

					<!--处理信息（完成任务时填写）-->
					<div v-if="detailData.task_state == 3" class="task-record">
						<c-title>处理记录</c-title>
						
						<c-detail style="padding-top: 0;">
							<c-detail-item label="处理记录">{{detailData.handle_record || '-'}}</c-detail-item>
							<c-detail-item label="处理附件">
								<c-file v-for="(file, i) in handleAttachmentList" :key="i" :src="file"></c-file>
							</c-detail-item>
							<custom-detail work-type="52" :data="detailData.handleCustomFieldValues" table></custom-detail>
						</c-detail>
					</div>
				</div>

				<div class="detail-button flex-start-center">
					<c-button v-if="auth('b_collabtask_accept') && detailData.task_state == 1" v-lock="lock('b_collabtask_accept')" color="main" size="dialog" @click="acceptTask">接受</c-button>
					<c-button v-if="auth('b_collabtask_finish') && detailData.task_state == 2" v-lock="lock('b_collabtask_finish')" color="main" size="dialog" @click="finishTask">完成</c-button>
					<c-button v-if="auth('b_collabtask_accept') && detailData.task_state == 2" v-lock="lock('b_collabtask_accept')" size="dialog" @click="cancelAcceptTask">取消接受</c-button>
					<c-button v-if="auth('b_collabtask_restart') && detailData.task_state == 3" v-lock="lock('b_collabtask_restart')" size="dialog" @click="restartTask">重启</c-button>
					<c-button v-if="auth('b_collabtask_edit')" v-lock="lock('b_collabtask_edit')" size="dialog" @click="editTask">编辑</c-button>
					<c-button v-if="auth('b_collabtask_edit')" v-lock="lock('b_collabtask_edit')" size="dialog" color="red" @click="removeTask">删除</c-button>
				</div>
			</div>

			<div class="log flex-column">
				<div class="log-list flex-grow">
					<div v-if="hiddenLogsCount" class="log-develop">
						<p @click="showAllLogs = true">展开更早的 {{ascLogsList.length - 10}} 条动态...</p>
					</div>
					<ul>
						<li v-for="(item,i) in visibleLogsList" :key="i">
							<div class="log-info flex">
								<span>{{i + 1 + (!showAllLogs && ascLogsList.length > 10 ? ascLogsList.length - 10 : 0)}}.</span>
								<p class="flex flex-grow" style="gap: .5em">
									<span style="color: #000;">{{item.create_user_realname}}</span>
									<span>{{item.log_type == 2 ? '发表评论' : item.operation_name}}</span>
									<span v-if="item.duration_seconds">{{durationLabel(item.operation_name)}} {{durationText(item.duration_seconds)}}</span>
								</p>
								<span style="color: #bbb;">{{item.create_date}}</span>
							</div>
							<div v-if="item.remark" class="log-remark">
								<template v-if="item.log_type == 4">
									<div v-for="(change, j) in parseChanges(item.remark)" :key="j">
										<span>{{change.name}}：</span>
										<span class="change-old">{{change.old_value || '空'}}</span>
										<span class="change-arrow"> → </span>
										<span class="change-new">{{change.new_value || '空'}}</span>
									</div>
								</template>
								<template v-else>{{item.remark}}</template>
							</div>
						</li>
					</ul>
				</div>

				<div v-if="auth('b_collabtask_comment')" class="remark">
					<c-input v-model="commentText" type="textarea" name="remark" placeholder="评论内容写这里，Enter 换行 / Ctrl+Enter发送" maxlength="500" :height-resize="false" @focus="remarkShortcut(true)" @blur="remarkShortcut(false)"></c-input>
					<div class="remark-handle flex-end-center">
						<c-button size="dialog" color="main" @click="addComment">发送评论</c-button>
					</div>
				</div>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'collabTaskDetail',

		props: {
			id: [String, Number]
		},

		data() {
			return {
				detailData: {},
				attachmentList: [],
				handleAttachmentList: [],
				logsList: [],
				commentText: '',
				showAllLogs: false,
				//打开/刷新详情时的当前时间戳（计算未完成任务总时长）
				nowTime: 0,
				stateSteps: [
					{name: '待响应', state: 1},
					{name: '执行中', state: 2},
					{name: '已完成', state: 3}
				]
			}
		},

		computed: {
			/****步骤间时长（待响应→执行中：响应时长；执行中→已完成：处理时长）****/
			stepDurations() {
				return [
					this.detailData.accept_date ? this.durationText(this.detailData.response_seconds) : '',
					this.detailData.finish_date ? this.durationText(this.detailData.handle_seconds) : ''
				]
			},

			/****总时长（创建→完成，未完成则截至当前）****/
			totalSeconds() {
				let start = this.parseDate(this.detailData.create_date);
				if (!start) return null;
				let end = this.parseDate(this.detailData.finish_date) || this.nowTime;
				return Math.max(Math.floor((end - start) / 1000), 0);
			},

			/****关联单据类型定义****/
			refTypeData() {
				switch ((this.detailData.ref_type || '').toString()) {
				case '3':
					return {
						name: '生产工单',
						auth: 'm_work',
						comp: 'workDetail'
					}
				case '13':
					return {
						name: '生产任务',
						auth: 'm_task',
						comp: 'taskDetail'
					}
				default:
					return {};
				}
			},

			refClickable() {
				return !!(this.refTypeData.comp && this.auth(this.refTypeData.auth));
			},

			/****任务动态升序展示（旧→新，接口返回为倒序）****/
			ascLogsList() {
				return [...this.logsList].reverse();
			},

			visibleLogsList() {
				return this.showAllLogs ? this.ascLogsList : this.ascLogsList.slice(-10);
			},

			hiddenLogsCount() {
				return this.ascLogsList.length - this.visibleLogsList.length;
			}
		},

		methods: {
			open() {
				this.commentText = '';
				this.showAllLogs = false;
				this.loadDetail(true);
			},

			/****加载任务详情（openDialog=true 时打开弹窗）****/
			loadDetail(openDialog) {
				this.request({
					url: '/collab/task/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data;
						this.nowTime = Date.now();
						this.attachmentList = this.parseFiles(data.attachment_json);
						this.handleAttachmentList = this.parseFiles(data.handle_attachment_json);
						this.loadLogs();
						if (openDialog) {
							this.$refs.dialog.open();
						}
					}
				});
			},

			/****操作成功后：刷新详情 + 通知列表更新****/
			reload() {
				this.loadDetail(false);
				this.$emit('resolve');
			},

			/****解析附件JSON数组****/
			parseFiles(json) {
				return Array.isArray(json) ? json : [];
			},

			/****加载任务动态日志****/
			loadLogs() {
				this.request({
					url: '/collab/task/logs/list',
					data: {
						task_id: this.id
					},
					success: data => {
						this.logsList = data || [];
					}
				});
			},

			/****打开关联单据详情****/
			openRefDetail() {
				if (!this.refClickable) return;
				this.globalDialog(this.refTypeData.comp, {props: {id: this.detailData.ref_id}});
			},

			/******编辑任务*******/
			editTask() {
				this.globalDialog('collabTaskEdit', {data: {id: this.detailData.id}}, () => this.reload());
			},

			/******接受任务*******/
			acceptTask() {
				this.$confirm({
					message: '确认接受任务【' + this.detailData.task_title + '】？',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/accept',
							data: {id: this.detailData.id},
							loading: true,
							success: () => {
								this.$message({
									message: '已接受任务',
									type: 'success'
								});
								this.reload();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******取消接受任务*******/
			cancelAcceptTask() {
				this.$confirm({
					message: '确认取消接受任务【' + this.detailData.task_title + '】？任务将退回待响应状态',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/accept/cancel',
							data: {id: this.detailData.id},
							loading: true,
							success: () => {
								this.$message({
									message: '已取消接受',
									type: 'success'
								});
								this.reload();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******完成任务（填写处理记录）*******/
			finishTask() {
				this.globalDialog('collabTaskFinish', {data: this.detailData}, () => this.reload());
			},

			/******重启任务*******/
			restartTask() {
				this.$confirm({
					message: '确认重启任务【' + this.detailData.task_title + '】？任务将回到执行中状态，历史处理记录将保留',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/restart',
							data: {id: this.detailData.id},
							loading: true,
							success: () => {
								this.$message({
									message: '任务已重启',
									type: 'success'
								});
								this.reload();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******转移任务*******/
			transferTask() {
				this.globalDialog('collabTaskTransfer', {data: this.detailData}, () => this.reload());
			},

			/******删除任务（删除后关闭详情）*******/
			removeTask() {
				this.$confirm({
					message: '确认删除协同任务【' + this.detailData.task_title + '】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/remove',
							data: {id: this.detailData.id},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.$emit('resolve');
								this.$refs.dialog.close();
							}
						});
					},
					cancel: () => {}
				});
			},

			remarkShortcut(active) {
				if (active) {
					this._remarkShortcut = e => {
						if (e.code == 'Enter' && e.ctrlKey) {
							e.preventDefault();
							this.addComment();
						}
					}
					window.addEventListener('keydown', this._remarkShortcut);
				} else {
					window.removeEventListener('keydown', this._remarkShortcut);
				}
			},

			/****发表评论****/
			addComment() {
				if (!this.commentText || !this.commentText.trim()) {
					this.$message({
						message: '请填写评论内容',
						type: 'warn'
					});
					return;
				}
				this.request({
					url: '/collab/task/comment/add',
					data: {
						task_id: this.id,
						remark: this.commentText.trim()
					},
					loading: true,
					success: () => {
						this.commentText = '';
						this.$message({
							message: '评论成功',
							type: 'success'
						});
						this.loadLogs();
					}
				});
			},

			/****解析修改明细JSON数组（log_type=4）****/
			parseChanges(remark) {
				try {
					return JSON.parse(remark) || [];
				} catch (e) {
					return [];
				}
			},

			/****解析时间字符串为时间戳****/
			parseDate(str) {
				if (!str) return null;
				let time = new Date(str.toString().replace(/-/g, '/')).getTime();
				return isNaN(time) ? null : time;
			},

			/****日志时长标签（按操作类型区分响应/处理时长）****/
			durationLabel(operationName) {
				operationName = operationName || '';
				if (operationName.includes('完成')) return '处理时长';
				if (operationName.includes('接受') && !operationName.includes('取消')) return '响应时长';
				return '耗时';
			},

			/****时长展示文本（取最高两级非零单位，如 7时27分、12分33秒）****/
			durationText(seconds) {
				if (seconds === null || seconds === undefined || seconds === '') return '-';
				seconds = parseInt(seconds);
				if (isNaN(seconds) || seconds < 0) return '-';
				if (seconds === 0) return '0秒';
				let units = [
					{value: 86400, name: '天'},
					{value: 3600, name: '时'},
					{value: 60, name: '分'},
					{value: 1, name: '秒'}
				];
				let parts = [];
				for (let unit of units) {
					let count = Math.floor(seconds / unit.value);
					seconds %= unit.value;
					if (count) {
						parts.push(count + unit.name);
					}
					if (parts.length >= 2) break;
				}
				return parts.join('');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.detail {
		flex-grow: 680;
		width: 0;
		border-right: 1px solid var(--unit-line);

		&-scroll {
			overflow: auto;
					
			.head {
				height: 74px;
				padding: 0 22px 0 40px;
				background: #F9F9F9;

				.state-steps {
					gap: 150px;
				}

				.step-cell {
					position: relative;
				}

				.step-item {
					gap: 6px;
					position: relative;
					font-size: 13px;
					color: var(--color-main);

					&:before {
						content: '\e63f';
						display: flex;
						align-items: center;
						justify-content: center;
						z-index: 1;
						position: relative;
						box-sizing: border-box;
						width: 24px;
						height: 24px;
						border: 2px solid var(--color-main);
						border-radius: 50%;
						font-family: 'cms_font'
						font-size: 14px;
						color: #fff;
						background: var(--color-main);
					}

					&:not(:nth-last-child(1)):after {
						content: '';
						position: absolute;
						left: 50%;
						top: 12px;
						width: 180px;
						height: 2px;
						background: var(--color-main);
					}

					&.is-active:not(:nth-last-child(1)) {
						color: #000;

						&:before {
							content: '';
							border-color: var(--color-main);
							background: #fff;
						}

						&:after {
							background: #ccc;
						}
					}

					&.is-wait {
						color: #999;

						&:before {
							content: '';
							border-color: #ccc;
							background: #F2F2F2;
						}

						&:after {
							background: #ccc;
						}
					}
				}

				.arrow-duration {
					position: absolute;
					left: 100%;
					top: -4px;
					width: 150px;
					font-size: 12px;
					text-align: center;
					color: #666;
				}

				.total {
					gap: 10px;
					font-size: 12px;
					color: #999;

					div {
						font-size: 16px;
						font-weight: bold;
						color: var(--color-main);
					}
				}
			}

			.task {
				padding: 20px 24px;

				&-title {
					line-height: 32px;
					font-size: 20px;
					font-weight: bold;
					word-break: break-word;
					color: #1d2129;
				}

				&-info {
					margin-top: 10px;
					margin-right: 20px;
					font-size: 13px;
					color: #999;

					.tf {
						margin-right: 8px;
					}
				}
				
				&-desc {
					margin-top: 20px;
					line-height: 22px;
					font-size: 14px;
					color: #333;
					word-break: break-word;
				}

				&-file {
					margin-top: 10px;
				}

				&-date {
					display: grid;
					grid-template-columns: repeat(2, 1fr);
					grid-column-gap: 80px;
					margin-top: 10px;
					line-height: 32px;
					font-size: 13px;
					color: #999;
				}

				&-record {
					border-top: 8px solid #F5F5F5;

					>>> .c-title {
						margin: 10px 20px;
					}
				}
			}
		}

		&-button {
			gap: 12px;
			height: 60px;
			border-top: 1px solid var(--unit-line);
			padding: 0 20px;
		}
	}

	.log {
		flex-grow: 560;
		width: 0;

		&-develop {
			position: relative;
			box-sizing: border-box;
			padding: 12px 22px 0;
			line-height: 26px;
			font-size: 13px;
			text-decoration: underline;
			color: #666;

			p {
				cursor: pointer;

				&:hover {
					color: var(--color-main);
				}
			}
		}

		&-list {
			overflow: auto;

			ul {
				padding: 12px 22px;
				overflow: auto;

				^[-4..-3][vertical] ^[-2..-1] {
					max-height: 500px;
				}

				li {
					padding: 5px 0;
				}
			}
		}

		&-info {
			gap: .5em;
			line-height: 20px;
			font-size: 12px;
			word-break: break-word;
			color: #666;
		}

		&-remark {
			border-radius: 4px;
			padding: 5px 10px;
			margin-top: 5px;
			line-height: 20px;
			font-size: 12px;
			white-space: pre-wrap;
			word-break: break-word;
			background: #F9F9F9;

			.change-old {
				color: #999;
				text-decoration: line-through;
			}

			.change-arrow {
				margin: 0 .06rem;
				color: #999;
			}

			.change-new {
			}
		}
	}

	.remark {
		border-top: 1px solid #eee;

		>>> .c-input {
			height: 100px;
			border: none;
			box-shadow: none;

			textarea {
				padding: 16px 16px 0;
			}
		}

		&-handle {
			height: 60px;
			padding: 0 20px;

			>>> .c-button {
				border-radius: 4px;
			}
		}
	}
</style>
